import styled, { css } from 'styled-components';
import {device} from "../../device-sizes"

export const SlideImage = styled.img`
    flex-grow: 0;
    flex-shrink: 0;
    min-height: 100%;
    min-width: 900px;
    width: 100%;
    height: auto;
    position: absolute;
    transform:scale(1.3) translateY(100px);
    transition: all 0.700s ease-in-out;
    -webkit-transition: all 0.700s ease-in-out;
    opacity: 0;

    ${props => {if(props.slideactive){
      return css`
      transform:scale(1);
      transform: translateY(100px);
      opacity: 1;`
    }
   }
  }
`
export const SlideOverlay = styled.div`
  position:absolute;

  &>*{
    font-size:80px;
    color:#f3dcf9;
    opacity:1;
    text-shadow: 0px 0px 35px #ffffff, 0px 0px 35px #5c5c5c29;
  }

  @media ${device.mobile} {
    &>*{
      font-size:9vw;
    }
  }
`

export const SlideshowContainer = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 400px;
    overflow: hidden;
    background-color: rgb(29, 29, 29);

    @media ${device.mobile} {
        height: 43vh;
    }
`

export const CircleContainer = styled.div`
  display: flex;
  position: absolute;
  top: 90%;
`

export const Circle = styled.div`
  --circle-size: 14px;
  border-radius: 100%;
  width: var(--circle-size);
  height: var(--circle-size);
  border-style: solid;
  border-width: 3px;
  margin: 0 6px;
  opacity: 0.4;
  background-color: rgb(94, 145, 211);
  border-color: rgb(43, 43, 43);
  transition: all 0.2s ease-in;
  cursor: pointer;

  @media ${device.mobile} {
    width: 3vh;
    height: 3vh;
    max-width: var(--circle-size);
    max-height: var(--circle-size);
  }
`

export const SlideArrow = styled.svg`
  --arrow-size: 40px;
  --arrow-location: 4%;
  position: absolute;
  top: calc(50% - (var(--arrow-size) / 2));
  width: var(--arrow-size);
  height: var(--arrow-size);
  opacity: 0.6;
  cursor: pointer;
  transition: all 0.14s ease-in;


  & path{
    pointer-events:none;
  }

  /**Puts the arrow to the left if assing left*/
  ${props => {if(props.left){
        return css`
        left: calc(var(--arrow-location) - var(--arrow-size) + 20px);
        transform: rotate(180deg);
      `}
    else{
        return css`
        right: calc(var(--arrow-location) - var(--arrow-size) + 20px);
        `}
        }
    }

  &:hover{
    opacity: 1;
  }

  @media ${device.mobile} {
    --arrow-location: 9%;
    --arrow-size: calc(10% + 10px);
  }

`